<div role="search" class="searchbox-wrapper">
  <label class="searchbox">
    <input #faqOverviewSearchInput [placeholder]="'faqItems.overviewSearchBox.placeholder' | cxTranslate"
      autocomplete="off" aria-describedby="initialDescription" aria-controls="results" aria-autocomplete="both"
      [attr.aria-label]="'faqItems.overviewSearchBox.placeholder' | cxTranslate"
            (input)="change(faqOverviewSearchInput.value)" (keydown.enter)="
              search(faqOverviewSearchInput.value)" value="{{ chosenWord }}" />

      <div role="presentation" class="search-icon" [ngClass]="getSearchIconClass(faqOverviewSearchInput.value)"
        (click)="search(faqOverviewSearchInput.value)">
        <cx-icon [type]="iconType.SEARCH2" [ngClass]="getSearchIconClass(faqOverviewSearchInput.value)"></cx-icon>
      </div>
    </label>
  </div>
  @if (faqItemSuggestions$ | async; as faqItems) {
    <div class="results-dialog">
      <div class="results-wrapper">
        @if (faqItems.length > 0) {
          <div class="results">
            @for (faqItem of faqItems; track faqItem; let i = $index) {
              <div class="faq-item" [ngClass]="getFaqItemClass(i)">
                <a [routerLink]="{ cxRoute: getForwardRoute(), params: { faqItemCode: faqItem.code } } | cxUrl"
                  [queryParams]="{ search: faqOverviewSearchInput.value }" class="btn-link">
                  {{ faqItem?.title }}
                  <cx-icon [type]="iconType.CARET_RIGHT"></cx-icon>
                </a>
              </div>
            }
          </div>
        } @else {
          <div class="no-match-text">
            {{ 'faqItems.overviewSearchBox.help.noMatch' | cxTranslate }}
          </div>
        }
      </div>
    </div>
  }